function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { usePostHog } from '@posthog/react';
import { createPostHogAnalyticsSender, ProductAnalyticsEvent, setProductAnalyticsSender, trackProductAnalyticsEvent } from '@ui/app-components';
import { env } from '@ui/environment';
import { useEffect } from 'react';
const SUPER_PROPERTY_KEYS = [
    'workspace_level',
    'workspace_organization',
    'workspace_project',
    'workspace_application',
    'route_section',
    'route_subsection'
];
function decodeSegment(segment) {
    try {
        return decodeURIComponent(segment);
    } catch (unused) {
        return segment;
    }
}
function getRouteAnalyticsContext(pathname) {
    const segments = pathname.split('/').filter(Boolean).map(decodeSegment);
    const [root, first, second, third] = segments;
    if (root === 'org') {
        if (first && second && third) {
            const [route_section, route_subsection] = segments.slice(4);
            return {
                workspace_level: 'application',
                workspace_organization: first,
                workspace_project: second,
                workspace_application: third,
                route_section,
                route_subsection
            };
        }
        if (first && second) {
            const [route_section, route_subsection] = segments.slice(3);
            return {
                workspace_level: 'project',
                workspace_organization: first,
                workspace_project: second,
                route_section,
                route_subsection
            };
        }
        if (first) {
            const [route_section, route_subsection] = segments.slice(2);
            return {
                workspace_level: 'organization',
                workspace_organization: first,
                route_section,
                route_subsection
            };
        }
    }
    if (root === 'profile') {
        const [route_section, route_subsection] = segments.slice(1);
        return {
            workspace_level: 'profile',
            route_section,
            route_subsection
        };
    }
    const [route_section, route_subsection] = segments;
    return {
        workspace_level: 'public',
        route_section,
        route_subsection
    };
}
function routeContextToProperties(context) {
    return context;
}
function applySuperProperties(posthog, context) {
    for (const key of SUPER_PROPERTY_KEYS){
        const value = context[key];
        if (value) {
            posthog.register({
                [key]: value
            });
            continue;
        }
        posthog.unregister(key);
    }
}
function getWorkspaceKey(context) {
    var _context_workspace_organization, _context_workspace_project, _context_workspace_application;
    if (context.workspace_level === 'public' || context.workspace_level === 'profile') {
        return '';
    }
    return [
        context.workspace_level,
        (_context_workspace_organization = context.workspace_organization) !== null && _context_workspace_organization !== void 0 ? _context_workspace_organization : '',
        (_context_workspace_project = context.workspace_project) !== null && _context_workspace_project !== void 0 ? _context_workspace_project : '',
        (_context_workspace_application = context.workspace_application) !== null && _context_workspace_application !== void 0 ? _context_workspace_application : ''
    ].join('|');
}
export function PostHogRouterSync(props) {
    const posthog = usePostHog();
    useEffect(()=>{
        if (!env.PUBLIC_USE_POSTHOG) {
            return;
        }
        setProductAnalyticsSender(createPostHogAnalyticsSender(posthog));
        let lastCapturedHref = '';
        let lastWorkspaceKey = '';
        const capturePageview = ()=>{
            const currentHref = window.location.href;
            if (currentHref === lastCapturedHref) {
                return;
            }
            const pathname = window.location.pathname;
            const routeContext = getRouteAnalyticsContext(pathname);
            const routeContextProperties = routeContextToProperties(routeContext);
            applySuperProperties(posthog, routeContext);
            const workspaceKey = getWorkspaceKey(routeContext);
            if (workspaceKey && workspaceKey !== lastWorkspaceKey) {
                trackProductAnalyticsEvent(ProductAnalyticsEvent.WorkspaceSelected, _object_spread({
                    workspace_key: workspaceKey,
                    pathname
                }, routeContextProperties));
            }
            lastWorkspaceKey = workspaceKey;
            lastCapturedHref = currentHref;
        };
        const unsubscribe = props.router.subscribe('onResolved', capturePageview);
        capturePageview(); // initial
        return ()=>{
            unsubscribe();
            setProductAnalyticsSender(null);
        };
    }, [
        posthog,
        props.router
    ]);
    return null;
}
